export enum AppRoutes {
  root = '/',
  operationsDashboard = '/dashboard',
  storage = '/storage',
  transportSummary = '/transport-movement',
  vessels = '/vessel',
  vin = '/vin',
  order = '/order',
  shippingPlan = '/shipping-plan',
  rolesAdmin = '/rolesadmin',
  manageUser = '/manage',
  manageUsers = '/manage-users',
  pipeline = '/pipeline',
  systemAdministration = '/admin',
  documentManagement = '/document-management',
  uploadFile = '/admin/:movementId/upload-file',
  customerManagement = '/customer-management',
  productImages = '/product-images',
  inspection = '/inspection/:id',
  inspections = '/inspections',
  damages = '/damages',
  passport = '/passport',
  pts = '/pts',
  reports = '/reports',
  jobs = '/jobs',
  loadlanes = '/load-lane',
  commandCentre = '/command-centre',
  questionnaireTemplates = '/questionnaire-templates',
  questionnaireResponses = '/questionnaire-responses',
  releaseNotes = '/release-notes',
}

export enum SystemAdministrationRoutes {
  jobs = `/admin/jobs`,
  jobChainTemplates = `/admin/jobs/job-chain-templates`,
  locations = `/admin/locations`,
  transportUnits = `/admin/transportation`,
  companies = `/admin/companies`,
  shippingPlan = `/admin/shipping-plan`,
  checklist = `/admin/checklist`,
  inspectionStatusAccessRules = `/admin/inspection-status-access-rules`,
  emailNotificationAccess = `/admin/email-notification-access`,
  vesselManagement = `/admin/vessel`,
  stockReconciliation = `/admin/stock-reconciliation`,
}

export enum AppPaths {
  jobs = 'jobs',
  jobChainTemplates = 'jobs/job-chain-templates',
  locations = 'locations',
  transportation = 'transportation',
  companies = 'companies',
  shippingPlan = 'shipping-plan',
  uploadFile = 'upload-file',
  checklist = 'checklist',
  inspectionStatusAccessRules = 'inspection-status-access-rules',
  emailNotificationAccess = 'email-notification-access',
  vesselManagement = 'vessel',
  stockReconciliation = 'stock-reconciliation',
  inspection = 'inspection',
  mechanical = 'mechanical',
  mechanicalApproved = 'mechanical/approved',
  vehicle = 'vehicle',
  vehicleApproved = 'vehicle/approved',
}
